import Main from './Main.vue'
// import GMaps from '../mapa/components/GoogleMap'

export default [{
  path: 'maps',
  name: 'maps',
  component: Main,
  children: [
    // {path: '/', component: GMaps, name: 'maps'}
  ]
}
]



// WEBPACK FOOTER //
// ./src/app/website/mapa/routes.js